import { render, staticRenderFns } from "./botStatus.vue?vue&type=template&id=4c4814c2&"
import script from "./botStatus.vue?vue&type=script&lang=js&"
export * from "./botStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports